import TileSelector, { TileSelectorProps } from './TileSelector';

export default TileSelector;
export { TileSelectorProps };
